import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { combineReducers } from 'redux';
import { educationMaterialGroupsApi } from '../services/education-material-groups';
import { propertyTeaserApi } from '../services/property-teaser';
import { adminsReducer } from './admin/reducers';
import { educationMaterialsReducer } from './education-materials/reducers';
import { familyUserRolesReducer } from './family-user-role/reducers';
import { loansReducer } from './loan/reducers';
import { masterDataReducer } from './masterdata/reducers';
import { propertiesReducer } from './properties/reducers';
import { propertyReducer } from './property/reducers';
import { rolesReducer } from './roles/reducers';
import { rulesReducer } from './rules/reducers';
import { securitiesReducer } from './security/reducers';
import { sessionsReducer } from './sessions/reducers';
import { transactionsReducer } from './transactions/reducers';
import { usersReducer } from './users/reducers';

const rootReducer = combineReducers({
  properties: propertiesReducer,
  property: propertyReducer,
  users: usersReducer,
  rules: rulesReducer,
  roles: rolesReducer,
  admins: adminsReducer,
  securities: securitiesReducer,
  sessions: sessionsReducer,
  transactions: transactionsReducer,
  masterData: masterDataReducer,
  loans: loansReducer,
  educationMaterials: educationMaterialsReducer,
  familyUserRoles: familyUserRolesReducer,

  [propertyTeaserApi.reducerPath]: propertyTeaserApi.reducer,
  [educationMaterialGroupsApi.reducerPath]: educationMaterialGroupsApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware().concat(propertyTeaserApi.middleware, educationMaterialGroupsApi.middleware);
  },
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

export default store;
